cb.define(['common/common_VM.Extend.js'], function (common) {
  var AA_aa_optlist_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      common.initRegionAndPosition(viewmodel);
      viewmodel.on('afterInit', function () {
        viewmodel.get('iStatus').getFromModel().setValue(1);
      });
      viewmodel.on('beforeSearch', function (args) {
        args.commonVOs[0].value2 = 'test';
      });
    }
  }
  try {
    module.exports = AA_aa_optlist_filterVM_Extend;
  } catch (error) {

  }
  return AA_aa_optlist_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_optlist_filterVM.Extend.js